import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MenuLink } from '../../interfaces/menu-link.model';
import { LinksService } from '../../services/links.service';
import { LinkType } from '../../enums/link-type.enum';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent implements OnInit {
  menuOpened: boolean = false;
  subnavVisible: boolean = false;
  url: string;
  // links: MenuLink[] = [];
  linksCurrentPeriod: MenuLink[];
  linksArchivePeriod: MenuLink[];
  recitationlinks: MenuLink[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: LinksService
  ) {}

  ngOnInit() {
    this.router.events.subscribe(val => {
      this.subnavVisible = this.router.url === '/';
      this.url = this.router.url;
    });

    this.service.get().subscribe(a => {
      const links = a.map(link => {
        return <MenuLink>{
          id: link.id,
          title: link.title,
          url: link.Externe_Url || link.url,
          linkType: link.InformationLink
            ? LinkType.information
            : LinkType.edition,
          inArchive: link.InArchive,
        };
      });

      this.linksCurrentPeriod = links.filter(item => !item.inArchive);
      this.linksArchivePeriod = links.filter(item => item.inArchive);

      // console.log(this.linksCurrentPeriod);

      // this.links = a.map(link => {
      //   return <MenuLink>{
      //     id: link.id,
      //     title: link.title,
      //     url: link.Externe_Url || link.url,
      //     linkType: link.InformationLink ? LinkType.information : LinkType.edition
      //   };
      // });
    });

    // this.service.getRecitations()
    //   .subscribe((a) => {
    //     this.recitationlinks = a.map(link => {
    //       return <MenuLink>{
    //         id: link.id,
    //         title: link.titel,
    //         url: link.url,
    //         linkType: LinkType.recitation
    //       };
    //     });
    //   });
  }

  toggleMenu() {
    const $body = document.body;
    this.menuOpened = !this.menuOpened;
    this.menuOpened
      ? $body.classList.add('disable-scroll')
      : $body.classList.remove('disable-scroll');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/nav/nav.component.ts